var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "            <div class=\"sda-preview-image-container\" data-rendition=\""
    + alias2(alias1(depth0, depth0))
    + "\">\n                <div data-msg=\"resolultion warning\" class=\"\"></div>\n                <img data-rendition=\""
    + alias2(alias1(depth0, depth0))
    + "\" />\n            </div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"fly-over-content\">\n    <div class=\"sda-image-modal-flyover-header\">\n        <div class=\"sda-btns-horizontal\">\n            <a id=\"image-preview-close\" class=\"sda-btn-icon fa-times\"></a>\n        </div>\n    </div>\n    <div class=\"sda-image-modal-flyover-body\">\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "    </div>\n</div>\n";
},"useData":true});